import ProfileSettings from "@/components/ProfileSettings";

export default function AdminSettings() {
  return (
    <div className="space-y-8">
      <div>
        <div className="text-[11px] uppercase tracking-[0.4em] text-[#8E9AA6] mb-2">Operations · Settings</div>
        <h1 className="font-serif text-3xl md:text-4xl font-semibold tracking-tight text-white">
          Profile &amp; Security
        </h1>
      </div>
      <ProfileSettings />
    </div>
  );
}
